/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, spaceName: NonNullable<unknown> }} Chat_Mentions_Link_File_DescriptionInputs */



/**
* | output |
* | --- |
* | "\"{name}\" is not linked to this project yet, so the assistant cannot read it. Link just this file, or all of \"{spaceName}\" so the assistant can search the who..." |
*
* @param {Chat_Mentions_Link_File_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_file_description = /** @type {((inputs: Chat_Mentions_Link_File_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_File_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.name}“ ist noch nicht mit diesem Projekt verknüpft und kann daher nicht gelesen werden. Entweder nur diese Datei verknüpfen oder den gesamten Space „${i?.spaceName}“, damit der Assistent darin suchen kann.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" is not linked to this project yet, so the assistant cannot read it. Link just this file, or all of "${i?.spaceName}" so the assistant can search the whole space.`)
});